import React from "react";
import Pricing from "../../Pricing";

export default function Services() {
  return <>{<Pricing />}</>;
}
